// extracted by mini-css-extract-plugin
module.exports = {"activeNav":"#c19aea"};